import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { BREAKPOINTS } from "context/media/MediaConstant";

import { WizardStyleProps } from "./Wizard.constants";

export const StyledWizardContainer = styled.div<{
  outerContainerWidth: number;
}>`
  width: ${({ outerContainerWidth }) => `${outerContainerWidth + 161}px`};

  overflow: hidden;
  pointer-events: none;

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    width: fit-content;
  }
`;

export const StyledOuterContainer = styled.div<WizardStyleProps>`
  width: max-content;
  height: 80px;

  display: flex;
  position: relative;
  align-items: center;

  padding-left: 16px;

  ${({ scrollOffSet }) => `transform: translateX(-${scrollOffSet}px)`};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    margin-top: 16px;
  }
`;

export const StyledInnerContainer = styled.div`
  min-width: max-content;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledLine = styled.div<WizardStyleProps>`
  width: 10px;
  height: 2px;

  margin: 12px 8px 9px 7px;

  background: ${({ isNextStep }) =>
    isNextStep
      ? DIGIPOSTHEME.colors.secondaryAkbankBlack
      : DIGIPOSTHEME.colors.secondaryGraySecondary};

  border-radius: 1px;
`;

export const StyledCircle = styled.span<WizardStyleProps>`
  width: 20px;

  display: inline-block;

  margin-right: 5px;

  font-family: "Campton";
  font-size: 10px;
  font-weight: 500;
  color: white;
  line-height: 20px;
  text-align: center;

  border-radius: 50%;

  background: ${({ isNextStep }) =>
    isNextStep
      ? DIGIPOSTHEME.colors.secondaryAkbankBlack
      : DIGIPOSTHEME.colors.secondaryGraySecondary};
`;
